import axios from 'axios';

import config from '../config.json';

const instance = axios.create({
	baseURL: config[process.env.REACT_APP_ENV].api
});

instance.defaults.headers.common['x-api-key'] =
	config[process.env.REACT_APP_ENV].key;

export default instance;
